import { Modal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import WarningIcon from "../../../svg/warningIcon";

interface UpdateCigNoteConfirmationDialogProps {
  onSave: () => void;
  onClose: () => void;
  onCancel: () => void;
  loading: boolean;
  source: "j_codes" | "cig_notes" | "documents";
}

const updateCigNoteConfirmationDialog = (
  props: UpdateCigNoteConfirmationDialogProps,
) => {
  return (
    <Modal
      dialogId={ModalId.UPDATE_CIG_NOTE_CONFIRMATION_DIALOG}
      title={
        props.source === "j_codes"
          ? "J-Codes Update Confirmation"
          : props.source === "cig_notes"
            ? "Note Update Confirmation"
            : "Document Update Confirmation"
      }
      onSave={props.onSave}
      onClose={props.onClose}
      onCancel={props.onCancel}
      saveButtonText={props.loading ? "Updating..." : "Yes, Confirm"}
      cancelText="No, Cancel"
      disableSave={props.loading}
    >
      <div className="update-confirmation--conatiner flex flex-col items-center justify-center gap-3 p-4">
        <div className="warning-icon">
          <WarningIcon />
        </div>
        <div className="warning-message text-center text-body font-normal text-primaryGray-1">
          {props.source === "j_codes"
            ? "Are your sure you want to update details for the J-Codes ?"
            : props.source === "cig_notes"
              ? "Are your sure you want to write back the notes and update the  radio buttons ?"
              : "Are your sure you want to upload the documents ?"}
        </div>
      </div>
    </Modal>
  );
};

export default updateCigNoteConfirmationDialog;
